import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/**
 * @param String name
 * @param String description
 * @param Boolean white text style
 * @
 *
 * User name with avatar and role description
 *
 */
export const Persona = _ref => {
  let {
    user,
    description,
    whiteText
  } = _ref;
  const initials = [user.first_name, user.middle_name, user.last_name].map((w, i) => (w?.substring(0, 1) || '').toUpperCase()).join('');
  const fullName = [user.first_name, user.middle_name, user.last_name].map(x => x || '').join(' ');
  const fullNameDiv = /*#__PURE__*/React.createElement("div", {
    className: `persona-name ${whiteText ? 'persona-text-white' : ''}`
  }, fullName.length > 20 ? fullName.substring(0, 20) + '...' : fullName);
  return /*#__PURE__*/React.createElement("div", {
    className: "persona-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `persona-image ${whiteText ? 'persona-image-white' : ''}`
  }, initials), /*#__PURE__*/React.createElement("div", {
    className: 'persona-name-block'
  }, fullName.length > 20 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: 'right',
    placement: 'right',
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, fullName)
  }, fullNameDiv) : fullNameDiv, /*#__PURE__*/React.createElement("div", {
    className: `persona-description ${whiteText ? 'persona-text-white' : ''}`
  }, description)));
};